export const checkMedicare = (medicare: string) => {
  if (!medicare) {
    return false;
  }
  const digits = medicare.replace(/\s+/g, '').split('').map(Number);

  // Check if the Medicare number has 10 digits
  if (digits.length !== 10) {
    return false;
  }

  // Ensure the first digit is in the range 2 to 6
  if (digits[0] < 2 || digits[0] > 6) {
    return false;
  }

  // Calculate the check digit
  const sum =
    digits[0] +
    digits[1] * 3 +
    digits[2] * 7 +
    digits[3] * 9 +
    digits[4] +
    digits[5] * 3 +
    digits[6] * 7 +
    digits[7] * 9;

  // Check if the sum divided by 10 is the check digit
  if (sum % 10 === digits[8]) {
    return true;
  } else {
    return false;
  }
};
